import React, { useState } from "react";
import { Form, Input, Button, Card, message, Select, Switch, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import { apiService } from "@/services/api";

const { Option } = Select;

export const UserCreate: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      await apiService.createUser({
        username: values.username,
        email: values.email,
        password: values.password,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        roles: values.roles || [],
        enabled: values.enabled !== false,
        emailVerified: values.emailVerified || false,
      });
      message.success("Utilisateur créé avec succès");
      navigate("/users");
    } catch (e: any) {
      message.error(
        e?.response?.data?.message || "Erreur lors de la création de l'utilisateur"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Créer un nouvel utilisateur">
      <Form layout="vertical" onFinish={onFinish} initialValues={{ enabled: true }}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nom d'utilisateur"
              name="username"
              rules={[
                { required: true, message: "Le nom d'utilisateur est requis" },
                { min: 3, message: "Minimum 3 caractères" },
              ]}
            >
              <Input placeholder="john_doe" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "L'email est requis" },
                { type: "email", message: "Email invalide" },
              ]}
            >
              <Input placeholder="john.doe@filmika.io" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Prénom"
              name="firstName"
            >
              <Input placeholder="John" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Nom"
              name="lastName"
            >
              <Input placeholder="Doe" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Téléphone"
              name="phone"
            >
              <Input placeholder="+33 6 12 34 56 78" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Mot de passe"
              name="password"
              rules={[
                { required: true, message: "Le mot de passe est requis" },
                { min: 8, message: "Minimum 8 caractères" },
              ]}
            >
              <Input.Password placeholder="********" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Rôles"
          name="roles"
          rules={[{ required: true, message: "Au moins un rôle est requis" }]}
        >
          <Select
            mode="multiple"
            placeholder="Sélectionnez un ou plusieurs rôles"
            allowClear
          >
            <Option value="ADMIN">Administrateur</Option>
            <Option value="EDITOR">Éditeur</Option>
            <Option value="AUTHOR">Auteur</Option>
            <Option value="REVIEWER">Réviseur (lecture seule)</Option>
          </Select>
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Compte activé" name="enabled" valuePropName="checked">
              <Switch defaultChecked />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email vérifié"
              name="emailVerified"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Button type="primary" htmlType="submit" loading={loading}>
          Créer l'utilisateur
        </Button>
      </Form>
    </Card>
  );
};

export default UserCreate;
